


























import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";

@Component
class CurrencySelect extends Vue {
  @State(state => state.app.settings) settings;

  @Mutation("app/SET_SETTINGS") setSetting;

  sheet = false;

  get currency() {
    return this.settings.currency;
  }

  set currency(val) {
    this.setSetting({ ...this.settings, currency: val });
  }

  get text() {
    return this.$t(`setting.currency.${this.currency}`);
  }

  get currencyItems() {
    return [
      {
        value: "usd",
        text: this.$t("setting.currency.usd"),
        active: this.currency === "usd"
      },
      {
        value: "cny",
        text: this.$t("setting.currency.cny"),
        active: this.currency === "cny"
      },
      {
        value: "jpy",
        text: this.$t("setting.currency.jpy"),
        active: this.currency === "jpy"
      }
    ];
  }

  handleSelect(currency) {
    this.currency = currency.value;
    this.sheet = false;
  }
}
export default CurrencySelect;
